export class Visao {
    id: number;
    textoExibido: string;
    textoParaUrl: string;

    constructor(id: number, texto: string, textoUrl: string) {
        this.id = id;
        this.textoExibido = texto;
        this.textoParaUrl = textoUrl;
    }

    static getById(id: number) {
        const filtro = TODAS_AS_VISOES.filter(v => v.id == id);
        if (filtro) {
            return filtro[0];
        }
        return null;
    }

    static getByName(nome: string) {
        const filtro = TODAS_AS_VISOES.filter(v => v.textoParaUrl == nome);
        if (filtro) {
            return filtro[0];
        }
        return null;
    }

    isMultivigente() {
        return this.id == VISAO_MULTIVIGENTE.id;
    }

    isVigente() {
        return this.id == VISAO_VIGENTE.id;
    }

    isOriginal() {
        return this.id == VISAO_ORIGINAL.id || this.id == VISAO_ORIGINAL_CONJUNTA.id || this.id == VISAO_ORIGINAL_EXCLUSIVA.id;
    }

    isOriginalConjunta() {
        return VISAO_ORIGINAL_CONJUNTA.id;
    }

    isOriginalExclusiva() {
        return this.id == VISAO_ORIGINAL_EXCLUSIVA.id;
    }

    isRelacional() {
        return this.id == VISAO_RELACIONAL.id;
    }

    isAnotacao() {
        return this.id == VISAO_ANOTACAO.id || this.id == VISAO_ANOTACAO_ORIGEM.id || this.id == VISAO_ANOTACAO_DESTINO.id;
    }

    isAnotacaoOrigem() {
        return this.id == VISAO_ANOTACAO_ORIGEM.id;
    }

    isAnotacaoDestino() {
        return this.id == VISAO_ANOTACAO_DESTINO.id;
    }
}
export const VISAO_MULTIVIGENTE = new Visao(1, 'Multivigente', 'multivigente');
export const VISAO_VIGENTE = new Visao(2, 'Vigente', 'vigente');
export const VISAO_ORIGINAL = new Visao(3, 'Original', 'original');
export const VISAO_ORIGINAL_EXCLUSIVA = new Visao(4, 'Original', 'exclusiva');
export const VISAO_ORIGINAL_CONJUNTA = new Visao(5, 'Original', 'conjunta');
export const VISAO_RELACIONAL = new Visao(6, 'Relacional', 'relacional');
export const VISAO_ANOTACAO = new Visao(7, 'Anotação', 'visao-anotacao');
export const VISAO_ANOTACAO_ORIGEM = new Visao(8, 'Anotação', 'ativa');
export const VISAO_ANOTACAO_DESTINO = new Visao(9, 'Anotação', 'passiva');
export const VISOES_TELA = [VISAO_MULTIVIGENTE, VISAO_VIGENTE, VISAO_ORIGINAL, VISAO_RELACIONAL];
const TODAS_AS_VISOES = [VISAO_MULTIVIGENTE, VISAO_VIGENTE, VISAO_ORIGINAL, VISAO_RELACIONAL, VISAO_ORIGINAL_CONJUNTA, VISAO_ORIGINAL_EXCLUSIVA, VISAO_ANOTACAO_ORIGEM, VISAO_ANOTACAO_DESTINO];
